const Nav = () => {
  return (
    <>
      <nav id="sidebar" className="scrollspy">
        <div className="sidebar-header">
          <p className="h4">Conteúdo do manual</p>
        </div>

        <ul className="list-unstyled CTAs pb-0 mb-0 d-xss-none d-md-none">
          <li>
            <button
              className="btn btn-primary col-12"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#search-offcanvas"
              aria-controls="search-offcanvas"
              id="sidebar-search-btn"
            >
              <p className="d-inline" styled="color: #fff">
                Pesquisar
              </p>
              <i className="fa fa-search" styled="color: #fff;"></i>
            </button>
          </li>
        </ul>

        <ul className="list-unstyled components" id="sidebar-components">
          <li>
            <a
              href="#"
              data-toggle="collapse"
              aria-expanded="false"
              className="dropdown-toggle"
            >
              Início
            </a>
            <ul className="collapse list-unstyled" id="homeSubmenu">
              <li>
                <a href="#cuidados" className="dropdown-item nav-link">
                  Cuidados e segurança
                </a>
              </li>
              <li>
                <a href="#acesso-produto" className="dropdown-item nav-link">
                  Acesso ao equipamento
                </a>
              </li>
              <li>
                <a href="#guia-informacoes" className="dropdown-item nav-link">
                  Interface e informações gerais
                </a>
              </li>
            </ul>
          </li>

          <li>
            <a href="#guia-dashboard" className="dropdown-item nav-link">
              Dashboard
            </a>
          </li>

          <li>
            <a
              href="#"
              data-toggle="collapse"
              aria-expanded="false"
              className="dropdown-toggle"
            >
              Rede
            </a>
            <ul className="collapse list-unstyled">
              <li>
                <a href="#rede" className="dropdown-item nav-link">
                  Modo de operação
                </a>
              </li>
              <li>
                <a href="#wan" className="dropdown-item nav-link">
                  WAN
                </a>
              </li>
              <li>
                <a href="#lan" className="dropdown-item nav-link">
                  LAN
                </a>
              </li>
              <li>
                <a href="#dhcp" className="dropdown-item nav-link">
                  DHCP
                </a>
              </li>
              <li>
                <a href="#dns" className="dropdown-item nav-link">
                  DNS
                </a>
              </li>
              <li>
                <a href="#captive-portal" className="dropdown-item nav-link">
                  Captive Portal
                </a>
              </li>
              <li>
                <a href="#qos" className="dropdown-item nav-link">
                  QoS
                </a>
              </li>
              <li>
                <a href="#rotas" className="dropdown-item nav-link">
                  Rotas
                </a>
              </li>
            </ul>
          </li>

          <li>
            <a
              href="#"
              data-toggle="collapse"
              aria-expanded="false"
              className="dropdown-toggle"
            >
              Wireless
            </a>
            <ul className="collapse list-unstyled">
              <li>
                <a href="#wireless" className="dropdown-item nav-link">
                  Wireless
                </a>
              </li>
              <li>
                <a href="#wireless-acl" className="dropdown-item nav-link">
                  Wireless ACL
                </a>
              </li>
              <li>
                <a href="#wireless-avancado" className="dropdown-item nav-link">
                  Wireless avançado
                </a>
              </li>
              <li>
                <a
                  href="#wireless-radio-2_4ghz"
                  className="dropdown-item nav-link"
                >
                  Radio 2.4 Ghz
                </a>
              </li>
              <li>
                <a
                  href="#wireless-radio-5ghz"
                  className="dropdown-item nav-link"
                >
                  Radio 5 Ghz
                </a>
              </li>
              <li>
                <a href="#site-survey" className="dropdown-item nav-link">
                  Site survey
                </a>
              </li>
              <li>
                <a href="#radius" className="dropdown-item nav-link">
                  Radius
                </a>
              </li>
            </ul>
          </li>

          <li>
            <a
              href="#"
              data-toggle="collapse"
              aria-expanded="false"
              className="dropdown-toggle"
            >
              Sistema
            </a>
            <ul className="collapse list-unstyled">
              <li>
                <a href="#gerenciamento" className="dropdown-item nav-link">
                  Gerenciamento
                </a>
              </li>
              <li>
                <a href="#backup" className="dropdown-item nav-link">
                  Backup e restauração
                </a>
              </li>
              <li>
                <a href="#atualizacao-firm" className="dropdown-item nav-link">
                  Atualização de firmware
                </a>
              </li>
              <li>
                <a href="#inccloud" className="dropdown-item nav-link">
                  Integração INC Cloud
                </a>
              </li>
              <li>
                <a href="#log" className="dropdown-item nav-link">
                  Log
                </a>
              </li>
            </ul>
          </li>

          <li>
            <a
              href="#"
              data-toggle="collapse"
              aria-expanded="false"
              className="dropdown-toggle"
            >
              Serviços
            </a>
            <ul className="collapse list-unstyled">
              <li>
                <a href="#splash-page" className="dropdown-item nav-link">
                  Splash Page
                </a>
              </li>
              <li>
                <a href="#discovery" className="dropdown-item nav-link">
                  Discovery
                </a>
              </li>
              <li>
                <a href="#ntp" className="dropdown-item nav-link">
                  NTP
                </a>
              </li>
              <li>
                <a href="#snmp" className="dropdown-item nav-link">
                  SNMP
                </a>
              </li>
              <li>
                <a href="#watchdog" className="dropdown-item nav-link">
                  Watchdog
                </a>
              </li>
              <li>
                <a href="#ddns" className="dropdown-item nav-link">
                  DDNS
                </a>
              </li>
              <li>
                <a href="#agendamento" className="dropdown-item nav-link">
                  Agendamento
                </a>
              </li>
              <li>
                <a href="#led" className="dropdown-item nav-link">
                  LED
                </a>
              </li>
            </ul>
          </li>

          <li>
            <a
              href="#"
              data-toggle="collapse"
              aria-expanded="false"
              className="dropdown-toggle"
            >
              Segurança
            </a>
            <ul className="collapse list-unstyled">
              <li>
                <a href="#seguranca" className="dropdown-item nav-link">
                  Firewall
                </a>
              </li>
              <li>
                <a href="#dmz-portas" className="dropdown-item nav-link">
                  DMZ e red. de portas
                </a>
              </li>
              <li>
                <a href="#regras-firewall" className="dropdown-item nav-link">
                  Regras de firewall
                </a>
              </li>
            </ul>
          </li>

          <li>
            <a
              href="#"
              data-toggle="collapse"
              aria-expanded="false"
              className="dropdown-toggle"
            >
              Conexões
            </a>
            <ul className="collapse list-unstyled">
              <li>
                <a href="#conexoes" className="dropdown-item nav-link">
                  Dispositivos conectados
                </a>
              </li>
            </ul>
          </li>

          <li>
            <a href="#reset-padrao-fabrica" className="sidebar-item nav-link">
              Reset (padrão de fábrica)
            </a>
          </li>
          <li>
            <a href="#termo-garantia" className="sidebar-item nav-link">
              Termo de garantia
            </a>
          </li>
          <li>
            <a href="#fale-conosco" className="sidebar-item nav-link">
              Fale conosco
            </a>
          </li>
        </ul>

        <ul className="list-unstyled CTAs mb-0">
          <li>
            <a
              onClick={() => {
                window.print();
              }}
              data-tooltip="Exportar para PDF"
              className="tooltip-left"
            >
              <img src="./res/img/pdf.svg" />
            </a>
          </li>
        </ul>
      </nav>
    </>
  );
};

export default Nav;
